import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../utl/models/Message";
import { VendorsState } from "../models/VendorsState";

const setMessage = (state: VendorsState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;